export const formatTo12Hour = (timeStr) => {
  if (!timeStr) return "";

  const [hour, minute] = timeStr.split(":").map(Number);

  if (isNaN(hour) || isNaN(minute)) return timeStr;

  const period = hour >= 12 ? "PM" : "AM";
  const hour12 = hour % 12 || 12;

  return `${hour12}:${minute.toString().padStart(2, "0")} ${period}`;
};

export const formatFullDateTime = (isoString) => {
  if (!isoString) return "";

  const date = new Date(isoString);

  return date.toLocaleString("en-PH", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

/**
 * Returns the effective HH:mm time for display based on:
 * 1) client_signature_uploaded_at (ISO → HH:mm, Manila)
 * 2) fallback to legacy end_time (already HH:mm)
 */
export const getEffectiveEndTime = (jobOrder) => {
  if (!jobOrder) return "";

  // Prefer client signature timestamp
  if (jobOrder.client_signature_uploaded_at) {
    try {
      const d = new Date(jobOrder.client_signature_uploaded_at);

      return d.toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
        timeZone: "Asia/Manila",
      });
    } catch {
      // fallback below
    }
  }

  // fallback to legacy end_time
  return jobOrder.end_time || "";
};